import { EnumBase } from 'hay-core-react';
class PermissaoTipoEnum extends EnumBase {
    constructor() {
        super(
            ['main.permissao.tipo.entidade', 'main.permissao.tipo.processo'],
            'main.permissao.tipo.processo'
        );
    }
}

const instance = new PermissaoTipoEnum();
export default instance;
